import React from 'react';
import styles from './vtrg_custom_block.scss';
import VtrgVideoOnly from './vtrg_video_only.jsx';
import VtrgVideoOnlyFull from './vtrg_video_only_full.jsx';
import VtrgVideoOther from './vtrg_video_other.jsx';

const VtrgCustomBlock = ({ data, instanceType, instanceId, pieceType, slot, updatePiece, setActionLoading, ordn, afterUpdateVtrgPiece, getPieceForm }) => {
  
  if (typeof data.inner === 'string') {
    data.inner = { blocks: JSON.parse(data.inner) }
  }
  
  const current_video_full = data && (data.block_type === 1) &&  data.inner  && <VtrgVideoOnlyFull info={data.inner} />;
    const current_video_only = data && (data.block_type === 2)  &&  data.inner  && <VtrgVideoOnly info={data.inner} />;
    const current_video_other = data && (data.block_type === 3)  &&  data.inner  && <VtrgVideoOther info={data.inner} />;

    return (<div data-slot={slot}>
      {current_video_full && current_video_full}
      {current_video_only && current_video_only}
      {current_video_other && current_video_other}
    </div>);
};

export default VtrgCustomBlock;
